import { type FC } from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

import { useTexts } from '@/hooks/useTexts';

import { CenteredPageContent } from '../CenteredPageContent';
import { CopyrightSymbol } from './CopyrightSymbol';
import { FooterBanner } from './FooterBanner';

export const Footer: FC = () => {
  const texts = useTexts();
  return (
    <>
      <FooterBanner />
      <StyledCenteredPageContent>
        <Link to={texts.footer.privacyLink.url}>
          {texts.footer.privacyLink.text}
        </Link>
        <div>
          <CopyrightSymbol /> <span className="font-body">Storebrand</span>
        </div>
      </StyledCenteredPageContent>
    </>
  );
};

const StyledCenteredPageContent = styled(CenteredPageContent)`
  padding: 24px 0;
`;
